/**
 * Conservative offline shell: remember recent in-app routes the SW may have cached.
 * Never stores secrets — pathnames only.
 */

const STORAGE_KEY = 'aifit-offline-shell-v1';
const MAX_PATHS = 6;

const SAFE_PATH_RE =
  /^\/(es|en|pt|fr|de|nl|it|ru|zh|ja|ko|ar|hi|tr|pl)\/(dashboard\/(exercise-live|neuro-reset|triage|especialistas|metabolismo|nutricion|bionexos)|herramientas\/(recomendaciones|progreso|recordatorios|cuidado-personal|laboratorios|prescripciones|alertas|historial|consultas)|dashboard|agenda)\/?$/;

export function isSafeOfflinePath(pathname) {
  const path = String(pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  if (path.endsWith('/offline')) return false;
  return SAFE_PATH_RE.test(path);
}

export function readOfflineShellSnapshot() {
  if (typeof window === 'undefined') return { paths: [], updatedAt: null };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { paths: [], updatedAt: null };
    const parsed = JSON.parse(raw);
    const paths = Array.isArray(parsed?.paths)
      ? parsed.paths.filter((p) => isSafeOfflinePath(p)).slice(0, MAX_PATHS)
      : [];
    return { paths, updatedAt: parsed?.updatedAt || null };
  } catch {
    return { paths: [], updatedAt: null };
  }
}

export function rememberOfflineShellPath(pathname) {
  if (typeof window === 'undefined') return;
  if (!isSafeOfflinePath(pathname)) return;
  const path = String(pathname).split('?')[0].replace(/\/+$/, '');
  try {
    const current = readOfflineShellSnapshot();
    const paths = [path, ...current.paths.filter((p) => p !== path)].slice(0, MAX_PATHS);
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ paths, updatedAt: new Date().toISOString() })
    );
  } catch {
    // private mode / quota
  }
}
